import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LANGUAGE_STORAGE_KEY = 'app_language';
const TEXT_TRANSLATIONS = new WeakMap();
const ATTRIBUTE_TRANSLATIONS = new WeakMap();
const LOCALIZABLE_ATTRIBUTES = ['aria-label', 'placeholder', 'title', 'aria-description'];
const TRANSLATION_EXCLUSIONS = 'script, style, code, pre, textarea, [contenteditable="true"], [data-no-translate], .notranslate, .grammar-prose';

const getStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  return window.localStorage;
};

const translations = {
  Ballina: 'Startseite',
  Dashboard: 'Startseite',
  'Paneli yt i mësimit': 'Dein Lern-Dashboard',
  'Mirëdita, {name}!': 'Guten Tag, {name}!',
  'Vazhdo rrugëtimin tënd nga A1 deri në C2.': 'Setze deine Lernreise von A1 bis C2 fort.',
  'Vazhdo mësimin': 'Lerne weiter',
  'Mësimi yt i radhës është vetëm një klikim larg.': 'Deine nächste Lektion ist nur einen Klick entfernt.',
  'Leximi B2': 'Lesen B2',
  LEXIM: 'LESEN',
  'Tekste dhe ushtrime sipas formatit Goethe': 'Texte und Übungen im Goethe-Format',
  'Dëgjimi B2': 'Hören B2',
  DËGJIM: 'HÖREN',
  'Përmirëso kuptimin me audio autentike': 'Verbessere dein Hörverständnis mit authentischen Audios',
  'Përsëritja e fjalëve': 'Wortwiederholung',
  FJALOR: 'WORTSCHATZ',
  'fjalë pret': 'Wort wartet',
  'fjalë presin': 'Wörter warten',
  'për përsëritje': 'auf Wiederholung',
  'Mëso dhe përsërit fjalë të reja': 'Lerne und wiederhole neue Wörter',
  Gramatikë: 'Grammatik',
  'Përforco rregullat e gjermanishtes': 'Festige die Regeln der deutschen Grammatik',
  'Të folur': 'Sprechen',
  'Ushtrohu për pjesën Sprechen': 'Übe für den Prüfungsteil Sprechen',
  Shkrim: 'Schreiben',
  'Shkruaj më qartë dhe me siguri': 'Schreibe klarer und sicherer',
  'Ditë rresht': 'Tage in Folge',
  'Pikë XP': 'XP-Punkte',
  Saktësi: 'Genauigkeit',
  'Shumë mirë! Mos e ndërprit ritmin.': 'Sehr gut! Bleib dran.',
  'Fillo sot serinë tënde të mësimit.': 'Starte heute deine Lernserie.',
  'nga': 'von',
  'fjalë janë shënuar si të njohura.': 'Wörter sind als bekannt markiert.',
  'Ruaj fjalët e reja dhe ndërto fjalorin tënd.': 'Speichere neue Wörter und erweitere deinen Wortschatz.',
  'Hap fjalorin': 'Wortschatz öffnen',
  'Progresi i fjalorit': 'Wortschatzfortschritt',
  'Statistikat nuk mund të ngarkoheshin.': 'Statistiken konnten nicht geladen werden.',
  'Shiko të gjitha': 'Alle ansehen',
  'Fillo tani': 'Jetzt starten',
  'Rekomanduar për ty': 'Für dich empfohlen',
  'Zgjidh një aftësi për të ushtruar sot.': 'Wähle eine Fähigkeit, die du heute üben möchtest.',
  Përmbledhje: 'Übersicht',
  'Progresi yt': 'Dein Fortschritt',
  Qëndrueshmëria: 'Beständigkeit',
  'Seria javore': 'Wöchentliche Serie',
  FJALORI: 'WORTSCHATZ',
  'Përforco fjalët': 'Wortschatz festigen',
  'Fjalë të njohura': 'Bekannte Wörter',
  'Po ngarkohet': 'Wird geladen',
  Biseda: 'Chat',
  'Të gjitha bisedat': 'Alle Chats',
  'Shënimet e mia': 'Meine Notizen',
  'Shënimet e mia personale': 'Meine persönlichen Notizen',
  'Shënimet e mia personale...': 'Meine persönlichen Notizen ...',
  'Chat settings': 'Chat-Einstellungen',
  'Bisedë e re': 'Neuer Chat',
  'Krijo grup': 'Gruppe erstellen',
  'Zgjidhni një person për bisedë direkte': 'Wähle eine Person für einen Direktchat aus',
  'Emërto grupin dhe zgjidh anëtarët.': 'Gib der Gruppe einen Namen und wähle Mitglieder aus.',
  'Bisedë direkte': 'Direktchat',
  Grup: 'Gruppe',
  'Emri i grupit': 'Gruppenname',
  'Kërko sipas emrit...': 'Nach Namen suchen ...',
  'Tingujt aktivë': 'Töne aktiviert',
  'Tingujt joaktivë': 'Töne deaktiviert',
  'Njoftimet aktive': 'Benachrichtigungen aktiviert',
  'Njoftimet joaktive': 'Benachrichtigungen deaktiviert',
  Fiksuar: 'Angepinnt',
  'Fikso mesazhin': 'Nachricht anpinnen',
  'Fikso shënimet e mia': 'Meine Notizen anpinnen',
  'Fikso bisedën': 'Chat anpinnen',
  'Hiqe nga të fiksuarat': 'Aus den angepinnten Chats entfernen',
  'Nuk u gjet asnjë profil tjetër.': 'Keine weiteren Profile gefunden.',
  'Nuk u gjet asnjë përdorues.': 'Keine Benutzer gefunden.',
  'Biseda nuk u hap. Provoni përsëri.': 'Der Chat konnte nicht geöffnet werden. Bitte versuche es erneut.',
  'Grupi nuk u krijua. Kontrolloni lidhjen dhe provoni përsëri.': 'Die Gruppe konnte nicht erstellt werden. Bitte überprüfe deine Verbindung und versuche es erneut.',
  'Grupi nuk u krijua. Provoni përsëri.': 'Die Gruppe konnte nicht erstellt werden. Bitte versuche es erneut.',
  'Duke hapur...': 'Wird geöffnet ...',
  'Kërko në bisedë': 'Im Chat suchen',
  Informacion: 'Informationen',
  'Shko te mesazhi i fiksuar i mëparshëm': 'Zur vorherigen angehefteten Nachricht',
  'Shko te mesazhi i fiksuar pasues': 'Zur nächsten angehefteten Nachricht',
  'Mbylle njoftimin': 'Hinweis schließen',
  'Cancel selecting messages': 'Nachrichtenauswahl abbrechen',
  'Toggle message selection': 'Nachrichtenauswahl umschalten',
  'Cancel editing message': 'Bearbeiten der Nachricht abbrechen',
  'Hap emoji picker': 'Emoji-Auswahl öffnen',
  'Ndalo videon': 'Video ausschalten',
  'Nis videon': 'Video einschalten',
  'Shkruaj mesazh...': 'Nachricht schreiben ...',
  'Shkruaj mesazh për': 'Nachricht an',
  'Mesazh audio': 'Audionachricht',
  Bisedat: 'Chats',
  'Jashtë linje': 'Offline',
  'Online tani': 'Jetzt online',
  'Shkruaj Mesazh': 'Nachricht schreiben',
  Telefono: 'Anrufen',
  Sot: 'Heute',
  Fotot: 'Fotos',
  Skedarët: 'Dateien',
  'Të heshtura': 'Stummgeschaltet',
  'Të fshehura': 'Ausgeblendet',
  BISEDAT: 'CHATS',
  mechatronics: 'Mechatronik',
  programmer: 'Programmierer',
  'Student i Gjermanishtes': 'Deutschlernende Person',
  'Nxënës Gjermanisht': 'Deutschlernende Person',
  'Nxënës Gjermanishteje': 'Deutschlernende Person',
  'Grup Mësimor B2': 'B2-Lerngruppe',
  'Mësim Gjermanisht': 'Deutschunterricht',
  'Dje': 'Gestern',
  'Libri i Gramatikës': 'Grammatikbuch',
  Fjalor: 'Wortschatz',
  'Provimi Goethe B2': 'Goethe-B2-Prüfung',
  'Fjalë të Ruajtura': 'Gespeicherte Wörter',
  'Sfida e Kohës': 'Zeit-Challenge',
  Shtypi: 'Tipptraining',
  'Ditari i Shkrimit': 'Schreibjournal',
  Profesioni: 'Beruf',
  'Të Ruajturat': 'Lesezeichen',
  Cilësimet: 'Einstellungen',
  'Llogaria dhe aplikacioni': 'Konto und App',
  'Menaxho profilin, sigurinë dhe preferencat e aplikacionit.': 'Verwalte dein Profil, deine Sicherheit und App-Einstellungen.',
  'Profili yt': 'Dein Profil',
  'Siguria & E2E': 'Sicherheit & E2E',
  'Njoftimet & Audio': 'Benachrichtigungen & Audio',
  'Seksionet e cilësimeve': 'Einstellungsbereiche',
  'Ndrysho fotografinë': 'Profilbild ändern',
  'Hiqe fotografinë': 'Profilbild entfernen',
  'JPG, PNG ose WebP · maksimumi 5 MB': 'JPG, PNG oder WebP · maximal 5 MB',
  Emri: 'Vorname',
  Mbiemri: 'Nachname',
  'Email Adresa': 'E-Mail-Adresse',
  'Ruaj Ndryshimet': 'Änderungen speichern',
  'Ndrysho Fjalëkalimin': 'Passwort ändern',
  'Ndrysho fjalëkalimin': 'Passwort ändern',
  'Tingujt e ushtrimeve': 'Übungstöne',
  'Tingujt e bisedave': 'Chat-Töne',
  'Njoftimet në desktop': 'Desktop-Benachrichtigungen',
  'Përkujtuesi ditor i mësimit': 'Tägliche Lernerinnerung',
  'Ora e rikujtesës:': 'Erinnerungszeit:',
  'Gjuha e aplikacionit': 'App-Sprache',
  Gjuha: 'Sprache',
  Shqip: 'Albanisch',
  Gjermanisht: 'Deutsch',
  'Zgjidh gjuhën': 'Sprache auswählen',
  Njoftimet: 'Benachrichtigungen',
  'Hap cilësimet': 'Einstellungen öffnen',
  'Mbyll njoftimet': 'Benachrichtigungen schließen',
  'Të gjitha': 'Alle',
  'Të palexuara': 'Ungelesen',
  'Duke ngarkuar njoftimet...': 'Benachrichtigungen werden geladen ...',
  'Provo përsëri': 'Erneut versuchen',
  'Je në rregull': 'Alles erledigt',
  'Njoftime për mesazhet e chat-it': 'Benachrichtigungen zu Chat-Nachrichten',
  'Shëno të gjitha si të lexuara': 'Alle als gelesen markieren',
  'Mesazhet e palexuara të chat-it do të shfaqen këtu.': 'Ungelesene Chat-Nachrichten werden hier angezeigt.',
  'Mesazh i ri': 'Neue Nachricht',
  'Hap menynë e llogarisë': 'Kontomenü öffnen',
  'Menuja e llogarisë': 'Kontomenü',
  'Paneli i Kontrollit': 'Adminbereich',
  'Dil nga llogaria': 'Abmelden',
  Administrimi: 'Administration',
  'Njoftimet nuk u ngarkuan. Provo përsëri.': 'Benachrichtigungen konnten nicht geladen werden. Bitte versuche es erneut.',
  'Njoftimi nuk u hap. Provo përsëri.': 'Benachrichtigung konnte nicht geöffnet werden. Bitte versuche es erneut.',
  'Regjistrohu falas': 'Kostenlos registrieren',
  'Email-i nuk është konfirmuar': 'E-Mail-Adresse nicht bestätigt',
  'Shko te email-i yt dhe kliko linkun e konfirmimit.': 'Öffne deine E-Mail und klicke auf den Bestätigungslink.',
  Fjalëkalimi: 'Passwort',
  'ose vazhdo me': 'oder fortfahren mit',
  'Hyr këtu': 'Hier anmelden',
  'Kemi dërguar linkun te:': 'Wir haben den Link gesendet an:',
  '(opsionale)': '(optional)',
  Konfirmo: 'Bestätigen',
  Vazhdo: 'Weiter',
  Kushtet: 'Nutzungsbedingungen',
  Privatësinë: 'Datenschutz',
  'Fjalëkalimet nuk përputhen': 'Die Passwörter stimmen nicht überein',
  'Kthehu te të dhënat': 'Zurück zu den Angaben',
  'Mirë se vini përsëri': 'Willkommen zurück',
  'Hyni në llogarinë tuaj për të vazhduar mësimin.': 'Melde dich an, um mit dem Lernen fortzufahren.',
  'Nuk keni llogari?': 'Noch kein Konto?',
  'Email u ridërgua!': 'E-Mail erneut gesendet!',
  'Ridërgo email-in e konfirmimit': 'Bestätigungs-E-Mail erneut senden',
  'Keni harruar?': 'Passwort vergessen?',
  'Duke hyrë...': 'Anmeldung läuft ...',
  'Hyr në llogari': 'Anmelden',
  'Konfirmo email-in': 'E-Mail bestätigen',
  'Llogaria u krijua! Shko te email-i yt dhe kliko linkun.': 'Dein Konto wurde erstellt! Öffne deine E-Mail und klicke auf den Link.',
  'Hap aplikacionin e email-it': 'Öffne dein E-Mail-Programm',
  'Gjej email-in nga DeutschLernen': 'Suche die E-Mail von DeutschLernen',
  'Kthehu dhe hyr në platformë': 'Kehre zurück und melde dich an',
  'Ridërgo email-in': 'E-Mail erneut senden',
  'Kthehu te hyrja': 'Zurück zur Anmeldung',
  'Shkruaj emrin.': 'Gib deinen Vornamen ein.',
  'Shkruaj mbiemrin.': 'Gib deinen Nachnamen ein.',
  'Shkruaj email-in.': 'Gib deine E-Mail-Adresse ein.',
  'Email-i nuk është valid.': 'Die E-Mail-Adresse ist ungültig.',
  'Përdor të paktën 6 karaktere.': 'Verwende mindestens 6 Zeichen.',
  'Llogaria u krijua. Kontrollo email-in.': 'Konto erstellt. Bitte prüfe deine E-Mails.',
  'Krijo llogarinë': 'Konto erstellen',
  'Fillo falas dhe ndiq progresin tënd drejt B2.': 'Starte kostenlos und verfolge deinen Fortschritt bis B2.',
  'Keni llogari?': 'Du hast bereits ein Konto?',
  'p.sh. Mësues, infermier, programues...': 'z. B. Lehrer, Pflegekraft, Programmierer ...',
  'Konfirmo...': 'Bestätigen ...',
  'Fjalëkalimi...': 'Passwort ...',
  'Të dhënat që shfaqen në komunitet dhe biseda.': 'Diese Angaben werden in der Community und im Chat angezeigt.',
  'Menaxho tingujt e aplikacionit dhe njoftimet e bisedave.': 'Verwalte App-Töne und Chat-Benachrichtigungen.',
  'Luaj tingull kur përgjigjesh saktë në kuiz dhe ushtrime.': 'Spiele einen Ton ab, wenn du Quiz- und Übungsfragen richtig beantwortest.',
  'Njofto me tingull kur vjen një mesazh i ri.': 'Bei einer neuen Nachricht einen Ton abspielen.',
  'Shfaq njoftim kur vjen mesazh i ri, edhe kur biseda nuk është e hapur.': 'Zeige bei neuen Nachrichten eine Benachrichtigung an, auch wenn der Chat nicht geöffnet ist.',
  'Rikujtesë për të mos humbur serinë (streak).': 'Erinnere mich daran, meine Lernserie fortzusetzen.',
  Libraria: 'Bibliothek',
  'Kërko leksionin...': 'Lektion suchen ...',
  'Niveli CEFR': 'CEFR-Niveau',
  Kategoritë: 'Kategorien',
  Leksionet: 'Lektionen',
  'Asnjë temë e gjetur.': 'Kein Thema gefunden.',
  'Mirësevini në Librari': 'Willkommen in der Bibliothek',
  'Zgjidhni një kategori ose nivel për të filluar mësimin e gramatikës gjermane.': 'Wähle eine Kategorie oder ein Niveau, um mit dem Deutschlernen zu beginnen.',
  'Eksploro të gjitha leksionet rreth kësaj kategorie.': 'Entdecke alle Lektionen zu dieser Kategorie.',
  'Rruga juaj e mësimit': 'Dein Lernpfad',
  'Zgjidhni nivelin tuaj': 'Wähle dein Niveau',
  'Mësime gramatike të organizuara sipas niveleve CEFR.': 'Grammatiklektionen nach CEFR-Niveaus geordnet.',
  Rezultatet: 'Ergebnisse',
  'Zgjidhni një leksion më poshtë për të filluar.': 'Wähle unten eine Lektion aus, um zu beginnen.',
  'Nuk u gjet asnjë leksion.': 'Keine Lektion gefunden.',
  'Gati për të matur dijet?': 'Bereit, dein Wissen zu testen?',
  'Plotëso ushtrime rreth kësaj teme për të përforcuar njohuritë e tua të reja.': 'Bearbeite Übungen zu diesem Thema, um dein neues Wissen zu festigen.',
  'Fillo Ushtrimet': 'Übungen starten',
  Anulo: 'Abbrechen',
  Pyetja: 'Frage',
  'Ju përfunduat!': 'Du hast es geschafft!',
  'Rezultati juaj:': 'Dein Ergebnis:',
  'të sakta.': 'richtig.',
  '15 minuta lexim': '15 Minuten Lesezeit',
  'Hiq nga të ruajturat': 'Aus den Lesezeichen entfernen',
  'Ruaj temën': 'Thema speichern',
  'Shembuj nga Përdorimi': 'Anwendungsbeispiele',
  'Lista': 'Liste',
  'Kuiz': 'Quiz',
  'Kërko fjalë ose përkthim...': 'Wort oder Übersetzung suchen ...',
  'Përfshi shprehjet': 'Redewendungen einbeziehen',
  Kursi: 'Kurs',
  Lektion: 'Lektion',
  Kapitulli: 'Kapitel',
  Moduli: 'Modul',
  'Të gjitha leksionet': 'Alle Lektionen',
  'Të gjitha kapitujt': 'Alle Kapitel',
  'Të gjithë modulet': 'Alle Module',
  'Nuk u gjet asnjë fjalë.': 'Kein Wort gefunden.',
  'Paginimi i fjalorit': 'Wortschatzseiten',
  'Faqja e mëparshme': 'Vorherige Seite',
  'Faqja tjetër': 'Nächste Seite',
  'Kliko për të kthyer': 'Zum Umdrehen klicken',
  'Duhen të paktën 4 fjalë për kuizin.': 'Für das Quiz werden mindestens 4 Wörter benötigt.',
  'Kuiz i Shpejtë': 'Schnellquiz',
  'Kuiz i Përfunduar!': 'Quiz abgeschlossen!',
  'Zgjidhni të paktën një leksion me fjalë.': 'Wähle mindestens eine Lektion mit Wörtern aus.',
  'Kalon me ≥': 'Bestanden ab ≥',
  Këshilla: 'Tipps',
  'Shënimet tuaja për përgatitjen...': 'Deine Vorbereitungsnotizen ...',
  'Aktiv tani': 'Jetzt aktiv',
  'Cilësimet e chat-it': 'Chat-Einstellungen',
  'Kërko person ose bisedë': 'Person oder Chat suchen',
  Draft: 'Entwurf',
  Përcjellë: 'Weitergeleitet',
  Ndryshuar: 'Bearbeitet',
  'Duke ndryshuar mesazhin': 'Nachricht wird bearbeitet',
  'Përmend dikë': 'Jemanden erwähnen',
  'Zgjidhni një bisedë': 'Wähle einen Chat aus',
  'Skedarët e ndarë': 'Geteilte Dateien',
  'Nuk ka skedarë të ndarë në këtë bisedë.': 'In diesem Chat gibt es keine geteilten Dateien.',
  'Fshi shënimet e mia': 'Meine Notizen löschen',
  'Fshi bisedën vetëm për mua': 'Chat nur für mich löschen',
  'Shënimet tuaja personale fshihen menjëherë.': 'Deine persönlichen Notizen werden sofort gelöscht.',
  'Zgjidhni afatin. Mesazhet fshihen vetëm nga llogaria juaj.': 'Wähle einen Zeitraum. Die Nachrichten werden nur aus deinem Konto gelöscht.',
  'Pas 24 orësh': 'Nach 24 Stunden',
  'Pas 7 ditësh': 'Nach 7 Tagen',
  'Pas 1 muaji': 'Nach 1 Monat',
  'Fshihet vetëm nga llogaria juaj pas afatit': 'Wird nach Ablauf des Zeitraums nur aus deinem Konto gelöscht',
  'Hiqi menjëherë të gjitha shënimet nga llogaria jote': 'Alle Notizen sofort aus deinem Konto löschen',
  'Hiqi menjëherë dhe mbaji të fshehura vetëm në llogarinë tënde. Pjesëmarrësit e tjerë do t’i shohin ende.': 'Sofort entfernen und nur in deinem Konto ausblenden. Die anderen Teilnehmenden sehen sie weiterhin.',
  'Biseda nuk u pastrua. Provoni përsëri.': 'Der Chat konnte nicht geleert werden. Bitte versuche es erneut.',
  'Shko te mesazhet më të reja': 'Zu den neuesten Nachrichten',
  'Shko te mesazhi i fiksuar': 'Zur angehefteten Nachricht',
  'Mesazhi i mëparshëm': 'Vorherige Nachricht',
  'Mesazhi tjetër': 'Nächste Nachricht',
  'Hiqe fiksimin': 'Anheftung lösen',
  'Fshi bisedën nga llogaria jote': 'Chat aus deinem Konto löschen',
  'Nis thirrje me zë ose video (Google Meet style)': 'Sprach- oder Videoanruf starten',
  'Bashkëngjit skedar ose foto': 'Datei oder Foto anhängen',
  'Zgjidh emotikonë': 'Emoji auswählen',
  'Krijo anketë': 'Umfrage erstellen',
  'Regjistro zë': 'Sprachnachricht aufnehmen',
  'Përcill Mesazhin': 'Nachricht weiterleiten',
  'Zgjidhni bisedën ku dëshironi ta dërgoni': 'Wähle den Chat aus, an den du sie senden möchtest',
  'Përmbajtja që po përcillni:': 'Weitergeleiteter Inhalt:',
  'Kërko student, grup ose shënime...': 'Suche nach Person, Gruppe oder Notiz ...',
  'Nuk u gjet asnjë bisedë.': 'Kein Chat gefunden.',
  'Grup studimi': 'Lerngruppe',
  'Kërko studentë për të shtuar...': 'Suche Personen zum Hinzufügen ...',
  'Ngarko Skedarë': 'Dateien hochladen',
  'Imazhe, dokumente, PDF ose detyra gjermanisht': 'Bilder, Dokumente, PDFs oder Deutschaufgaben',
  'Shkruaj një shënim për këtë dokument...': 'Notiz zu diesem Dokument schreiben ...',
  'Tërhiq skedarët këtu ose kliko për të shfletuar': 'Ziehe Dateien hierher oder klicke, um sie auszuwählen',
  'Mbështeten JPG, PNG, PDF, DOC, TXT (Deri në 50 MB)': 'JPG, PNG, PDF, DOC und TXT werden unterstützt (bis zu 50 MB)',
  'Ngjesh imazhet (Compress images)': 'Bilder komprimieren',
  '~70% më e lehtë': '~70 % kleiner',
  'Përshkrim opsional (Caption)': 'Optionale Beschreibung',
  'Duke ngjeshur...': 'Wird komprimiert ...',
  'Dërgo Skedarët': 'Dateien senden',
  'Shto përgjigje': 'Antwort hinzufügen',
  'Dërgo anketën': 'Umfrage senden',
  Anketë: 'Umfrage',
  'Përgjigjet duhet të jenë të ndryshme.': 'Die Antworten müssen unterschiedlich sein.',
  'Shkruani pyetjen dhe të paktën dy përgjigje.': 'Gib eine Frage und mindestens zwei Antworten ein.',
  'Anketa nuk u krijua. Kontrolloni lidhjen dhe provoni përsëri.': 'Die Umfrage konnte nicht erstellt werden. Überprüfe die Verbindung und versuche es erneut.',
  'Njoftimet pa zë': 'Benachrichtigungen stummschalten',
  'Përgjigju': 'Antworten',
  'Ndrysho': 'Bearbeiten',
  'Përcill': 'Weiterleiten',
  'Kopjo': 'Kopieren',
  'Zgjidh': 'Auswählen',
  'Fshi': 'Löschen',
  'Fshi për mua': 'Für mich löschen',
  'Hiq vetëm nga biseda jote': 'Nur aus deinem Chat entfernen',
  'Fshi për të gjithë': 'Für alle löschen',
  'Hiq te të gjithë pjesëmarrësit': 'Für alle Teilnehmenden entfernen',
  'Ndaj profil': 'Profil teilen',
  'Zgjidhni profilin që doni të ndani në bisedë.': 'Wähle das Profil aus, das du im Chat teilen möchtest.',
  'Kërko profile...': 'Profile suchen ...',
  'Nuk u gjet asnjë profil.': 'Kein Profil gefunden.',
  'Profili nuk mund të shfaqet.': 'Das Profil kann nicht angezeigt werden.',
  'Më shumë reagime me emoji': 'Weitere Emoji-Reaktionen',
  'Mikrofoni është i fikur': 'Mikrofon ist ausgeschaltet',
  'Mikrofoni i çaktivizuar': 'Mikrofon deaktiviert',
  'Mikrofoni aktiv': 'Mikrofon aktiv',
  'Në dëgjim': 'Hört zu',
  'Duke folur...': 'Spricht ...',
  'Kamera aktive': 'Kamera eingeschaltet',
  'Kamera e fikur': 'Kamera ausgeschaltet',
  'Aktivizo Mikrofonin': 'Mikrofon einschalten',
  'Fik Mikrofonin': 'Mikrofon ausschalten',
  'Aktivizo Kamerën': 'Kamera einschalten',
  'Fik Kamerën': 'Kamera ausschalten',
  'Transmeto Ekranin': 'Bildschirm teilen',
  'Ndalo Transmetimin e Ekranit': 'Bildschirmfreigabe beenden',
  'Ngri Dorën': 'Hand heben',
  'Ule Dorën': 'Hand senken',
  Pjesëmarrësit: 'Teilnehmende',
  'Pjesëmarrësit (2)': 'Teilnehmende (2)',
  'Transmetimi i ekranit në kohë reale': 'Bildschirm wird live übertragen',
  'E Enkriptuar (E2E)': 'Ende-zu-Ende verschlüsselt (E2E)',
  'Zgjero në ekran të plotë': 'Im Vollbild anzeigen',
  'Palos në dritare lundruese': 'In schwebendes Fenster minimieren',
  'Ju (Nxënës)': 'Du (Lernende/r)',
  'Lidhje aktive': 'Verbindung aktiv',
  Përfundo: 'Beenden',
  'Mbyll dritaren': 'Fenster schließen',
  Mbyll: 'Schließen',
  Pyetjet: 'Fragen',
  Përgjigjet: 'Antworten',
  'Çfarë dëshironi të pyesni?': 'Was möchtest du fragen?',
  'Anketa nuk mund të shfaqet.': 'Die Umfrage kann nicht angezeigt werden.',
  'Të dhënat e anketës janë të pavlefshme.': 'Die Umfragedaten sind ungültig.',
  'Voto ruajtur': 'Stimme gespeichert',
  'Zgjidhni një përgjigje': 'Wähle eine Antwort',
  '· Voto ruajtur': '· Stimme gespeichert',
  '· Zgjidhni një përgjigje': '· Wähle eine Antwort',
  vota: 'Stimmen',
  'skedar i zgjedhur': 'Datei ausgewählt',
  'skedarë të zgjedhur': 'Dateien ausgewählt',
  'Thirrje me Zë (E2E) •': 'Sprachanruf (E2E) •',
  'Bisedë praktike në Gjermanisht': 'Deutsch-Konversationsübung',
  'Përfundo thirrjen': 'Anruf beenden',
  'Në listën tënde': 'In deiner Liste',
  'Shto te fjalët që nuk i di': 'Zu unbekannten Wörtern hinzufügen',
  'Fjalët shfaqen me përkthimin në shqip.': 'Wörter werden mit albanischer Übersetzung angezeigt.',
  'Zgjidh nivelin dhe leksionin që dëshiron të studiosh. Fjalët shfaqen me përkthimin në shqip.': 'Wähle das Niveau und die Lektion aus, die du lernen möchtest. Wörter werden mit albanischer Übersetzung angezeigt.',
  'të ruajtura': 'gespeichert',
  fjalë: 'Wörter',
  shprehje: 'Redewendungen',
  'Shfaqen': 'Angezeigt',
  rezultate: 'Ergebnisse',
  'Të dhënat e profilit janë të pavlefshme.': 'Die Profildaten sind ungültig.',
  'Lidhja me supabase': 'Supabase-Verbindung',
  'Të folurit': 'Sprechen',
  Leximi: 'Lesen',
  Dëgjimi: 'Hören',
  Shkrimi: 'Schreiben',
  'Përgatitu për provimin Goethe B2': 'Bereite dich auf die Goethe-B2-Prüfung vor',
  'Provimi përbëhet nga katër module.': 'Die Prüfung besteht aus vier Modulen.',
  Fillimi: 'Start',
  'Fillo provimin': 'Prüfung starten',
  'Fillo ushtrimin': 'Übung starten',
  'Pyetja e mëparshme': 'Vorherige Frage',
  'Pyetja tjetër': 'Nächste Frage',
  'Përfundo provimin': 'Prüfung beenden',
  'Përfundo ushtrimin': 'Übung beenden',
  'Shfaq rezultatin': 'Ergebnis anzeigen',
  'Koha e mbetur': 'Verbleibende Zeit',
  'Përgjigjja jote': 'Deine Antwort',
  'Përgjigjja e saktë': 'Richtige Antwort',
  'Përgjigje e saktë': 'Richtige Antwort',
  'Përgjigje e gabuar': 'Falsche Antwort',
  Rezultati: 'Ergebnis',
  Pikët: 'Punkte',
  'Kthehu te provimet': 'Zurück zu den Prüfungen',
  'Lexo me kujdes udhëzimet': 'Lies die Anweisungen sorgfältig',
  Udhëzimet: 'Anweisungen',
  'Fjalët e tua': 'Deine Wörter',
  'Shkruaj këtu': 'Hier schreiben',
  Regjistro: 'Aufnehmen',
  'Ndal regjistrimin': 'Aufnahme stoppen',
  'Dëgjo regjistrimin': 'Aufnahme anhören',
  'Përgjigju me zë': 'Mündlich antworten',
  'Tema e diskutimit': 'Diskussionsthema',
  'Nuk ka të dhëna': 'Keine Daten vorhanden',
  Rishiko: 'Überprüfen',
  'Përmbledhje e provimit': 'Prüfungsübersicht',
  'Leximi dhe kuptimi': 'Leseverstehen',
  'Kuptimi i dëgjimit': 'Hörverstehen',
  'Të shkruarit': 'Schreiben',
  Kthehu: 'Zurück',
  Ruaj: 'Speichern',
  Fillo: 'Starten',
  'Exam 1 — Erwachsene': 'Prüfung 1 — Erwachsene',
  'Exam 2 — Jugendliche': 'Prüfung 2 — Jugendliche',
  '4 module': '4 Module',
  'Të gjitha kaluar': 'Alle bestanden',
  'Best:': 'Bestes Ergebnis:',
  'Rezultatet ruhen në llogarinë tuaj.': 'Deine Ergebnisse werden in deinem Konto gespeichert.',
  'Secili modul vlerësohet veç — duhet ≥ 60% në secilin.': 'Jedes Modul wird einzeln bewertet — in jedem sind mindestens 60 % erforderlich.',
  'Modulet Lesen/Hören përdorin formatin zyrtar të provimit.': 'Die Module Lesen/Hören verwenden das offizielle Prüfungsformat.',
  'Folësimi': 'Sprechen',
  'Merrni mendimet e bisedës suaj.': 'Sammelt die Meinungen in eurem Chat.',
  'Duke krijuar grupin...': 'Gruppe wird erstellt ...',
  'Palos (PiP)': 'Minimieren (PiP)',
  'Redemittel': 'Redemittel',
  'Ruajtur!': 'Gespeichert!',
  'Kohë e mbetur': 'Verbleibende Zeit',
  'Dërgo': 'Senden',
  'Vazhdo me': 'Weiter mit',
  'Nuk ka rezultate': 'Keine Ergebnisse',
  'Dëgjimi i provimit': 'Prüfungsteil Hören',
  'Të dhënat nuk janë të disponueshme.': 'Daten sind nicht verfügbar.',
  'Nuk u gjet asnjë rezultat.': 'Keine Ergebnisse gefunden.',
  'Fjalë e re': 'Neues Wort',
  'Shto fjalë': 'Wort hinzufügen',
  'Fjalët e ruajtura': 'Gespeicherte Wörter',
  'Kërko fjalët e ruajtura...': 'Gespeicherte Wörter suchen ...',
  'Shto te fjalët e ruajtura': 'Zu gespeicherten Wörtern hinzufügen',
  'Hiq nga fjalët e ruajtura': 'Aus gespeicherten Wörtern entfernen',
  'Nuk ke ruajtur ende fjalë.': 'Du hast noch keine Wörter gespeichert.',
  'Nuk ka fjalë për përsëritje.': 'Keine Wörter zur Wiederholung vorhanden.',
  'Përsërit fjalët': 'Wörter wiederholen',
  'Fjalët e panjohura': 'Unbekannte Wörter',
  'Shto fjalë të panjohur': 'Unbekanntes Wort hinzufügen',
  'Përkthimi': 'Übersetzung',
  'Shembull': 'Beispiel',
  'Shëno si të mësuar': 'Als gelernt markieren',
  'Shëno si të njohur': 'Als bekannt markieren',
  'Shëno si të panjohur': 'Als unbekannt markieren',
  'Nuk ke ende fjalë të ruajtura.': 'Du hast noch keine Wörter gespeichert.',
  'Kthehu te fjalori': 'Zurück zum Wortschatz',
  'Kërko fjalë...': 'Wörter suchen ...',
  'Përkthimi në shqip': 'Albanische Übersetzung',
  'Përkthimi në gjermanisht': 'Deutsche Übersetzung',
  'Shto një fjalë': 'Wort hinzufügen',
  'Shto një fjalë të re': 'Neues Wort hinzufügen',
  'Shto te fjalët e mia': 'Zu meinen Wörtern hinzufügen',
  'Ruaj fjalën': 'Wort speichern',
  'Fjalët e mia': 'Meine Wörter',
  'Përsëritje e planifikuar': 'Geplante Wiederholung',
  'Kontrollo përgjigjen': 'Antwort überprüfen',
  'Fillo përsëritjen': 'Wiederholung starten',
  'Përsëritja përfundoi!': 'Wiederholung abgeschlossen!',
  'Rezultati yt': 'Dein Ergebnis',
  'Përfundo kuizin': 'Quiz beenden',
  'Fillo kuizin': 'Quiz starten',
  'Kuiz i ri': 'Neues Quiz',
  'Përgjigjja e gabuar': 'Falsche Antwort',
  'Kontrollo': 'Überprüfen',
  'Provo sërish': 'Erneut versuchen',
  'Shto në fjalor': 'Zum Wortschatz hinzufügen',
  'Fjalë të reja': 'Neue Wörter',
  'Mëso fjalë të reja': 'Neue Wörter lernen',
  'Mëso fjalorin': 'Wortschatz lernen',
  'Të gjitha nivelet': 'Alle Niveaus',
  'Të gjitha modulet': 'Alle Module',
  'Të gjitha kurset': 'Alle Kurse',
  'Kapitujt': 'Kapitel',
  'Shprehjet': 'Redewendungen',
  'Fjalët': 'Wörter',
  'Përfshi fjalitë': 'Sätze einbeziehen',
  'Rezultatet e kërkimit': 'Suchergebnisse',
  'Numri i fjalëve': 'Anzahl der Wörter',
  'Fjalët e mësuara': 'Gelernte Wörter',
  'Fjalët për përsëritje': 'Wörter zur Wiederholung',
  'Përkthe': 'Übersetzen',
  'Përkthim': 'Übersetzung',
  'Trego përkthimin': 'Übersetzung anzeigen',
  'Fshih përkthimin': 'Übersetzung ausblenden',
  'Ktheje kartën': 'Karte umdrehen',
  'Karta tjetër': 'Nächste Karte',
  'Karta e mëparshme': 'Vorherige Karte',
  'Mësoje': 'Lernen',
  'E di': 'Ich weiß es',
  'Nuk e di': 'Ich weiß es nicht',
  'Përkthe në gjermanisht': 'Ins Deutsche übersetzen',
  'Përkthe në shqip': 'Ins Albanische übersetzen',
  'Verben (Foljet)': 'Verben',
  'Nomen (Emrat)': 'Nomen',
  'Artikel (Nyjet)': 'Artikel',
  'Kasus (Rastet)': 'Kasus',
  'Pronomen (Përemrat)': 'Pronomen',
  'Adjektive (Mbiemrat)': 'Adjektive',
  'Adverbien (Ndajfoljet)': 'Adverbien',
  'Präpositionen (Parafjalët)': 'Präpositionen',
  'Konjunktionen (Lidhëzat)': 'Konjunktionen',
  'Satzbau (Struktura)': 'Satzbau',
  'Passiv (Pësorja)': 'Passiv',
  'Fragen (Pyetjet)': 'Fragen',
  'Imperativ (Urdhërorja)': 'Imperativ',
  'Partikeln (Pjesëzat)': 'Partikeln',
  'Stil & Struktura': 'Stil und Struktur',
  Fillestar: 'Anfänger',
  Elementar: 'Grundstufe',
  Mesatar: 'Mittelstufe',
  'I pavarur': 'Selbstständig',
  'I avancuar': 'Fortgeschritten',
  Zotërim: 'Kompetenz',
  'Modellsatz zyrtar Goethe B2 për të rritur — katër module: Lesen (5 pjesë), Hören (4 pjesë), Schreiben (2 pjesë), Sprechen (2 pjesë).': 'Offizieller Goethe-B2-Modellsatz für Erwachsene — vier Module: Lesen (5 Teile), Hören (4 Teile), Schreiben (2 Teile), Sprechen (2 Teile).',
  'Forum, artikuj, komente, rregulla — 5 pjesë sipas Modellsatzit.': 'Forum, Artikel, Kommentare, Regeln — 5 Teile nach dem Modellsatz.',
  'Biseda, intervista, raporte radiofonike, ligjëratë — 4 pjesë.': 'Gespräche, Interviews, Radioberichte, Vortrag — 4 Teile.',
  'Forumsbeitrag (min. 150 fjalë) + Nachricht an Vorgesetzten (min. 100 fjalë).': 'Forumsbeitrag (mind. 150 Wörter) + Nachricht an Vorgesetzte (mind. 100 Wörter).',
  'Vortrag (~4 min) + Diskussion: Sollen Studierende ihre Professoren beurteilen?': 'Vortrag (ca. 4 Min.) + Diskussion: Sollen Studierende ihre Professoren beurteilen?',
  'Dëgjo audio': 'Audio anhören',
  'Luaj audio': 'Audio abspielen',
  'Ndalo audion': 'Audio anhalten',
  'Pyetjet e provimit': 'Prüfungsfragen',
  'Përgjigju pyetjeve': 'Fragen beantworten',
  'Përgjigjet e tua': 'Deine Antworten',
  'Përfundo dhe shiko rezultatin': 'Beenden und Ergebnis anzeigen',
  'Nuk ka përgjigje të sakta': 'Keine richtigen Antworten',
  'Urime!': 'Herzlichen Glückwunsch!',
  'Vazhdo të ushtrohesh!': 'Übe weiter!',
  'Kthehu në fillim': 'Zurück zum Anfang',
  'Bisedë grupore': 'Gruppenchat',
  'Nuk ke biseda ende': 'Du hast noch keine Chats',
  'Nuk ka mesazhe ende': 'Noch keine Nachrichten',
  'Shkruaj mesazhin...': 'Nachricht schreiben ...',
  'Dërgo mesazhin': 'Nachricht senden',
  'Shkruaj përgjigjen tënde...': 'Schreibe deine Antwort ...',
  'Ky përdorues është offline': 'Diese Person ist offline',
  'Nxënësi po shkruan...': 'Schreibt gerade ...',
  'Mesazhi u dërgua': 'Nachricht gesendet',
  'Mesazhi u fshi': 'Nachricht gelöscht',
  'Mesazhi u kopjua': 'Nachricht kopiert',
  'Mesazhi u ndryshua': 'Nachricht bearbeitet',
  'Asnjë mesazh i gjetur': 'Keine Nachricht gefunden',
  'Kërko në bisedë...': 'Chat durchsuchen ...',
  'Kërko në mesazhe...': 'Nachrichten durchsuchen ...',
  'Ngarko foto': 'Foto hochladen',
  'Përzgjidh skedar': 'Datei auswählen',
  'Zgjidh një person': 'Person auswählen',
  'Zgjidh anëtarët e grupit': 'Gruppenmitglieder auswählen',
  'Emri i bisedës': 'Chatname',
  'Krijo grupin': 'Gruppe erstellen',
  'Shto anëtarë': 'Mitglieder hinzufügen',
  'Anëtarët e grupit': 'Gruppenmitglieder',
  'Anketa u krijua': 'Umfrage erstellt',
  'Voto': 'Abstimmen',
  'Shiko rezultatet': 'Ergebnisse ansehen',
  'Mbyll thirrjen': 'Anruf beenden',
  'Aktivizo mikrofonin': 'Mikrofon einschalten',
  'Çaktivizo mikrofonin': 'Mikrofon ausschalten',
  'Aktivizo kamerën': 'Kamera einschalten',
  'Çaktivizo kamerën': 'Kamera ausschalten',
  'Kthe kamerën': 'Kamera wechseln',
  'Lidhja u ndërpre': 'Verbindung unterbrochen',
  'Duke u lidhur...': 'Verbindung wird hergestellt ...',
  'Thirrja përfundoi': 'Anruf beendet',
  'Përgjigju thirrjes': 'Anruf annehmen',
  'Refuzo thirrjen': 'Anruf ablehnen',
  'Ruaj Cilësimet e Audios': 'Audioeinstellungen speichern',
  'Mëso gjermanisht.': 'Lerne Deutsch.',
  'Fol më lirshëm.': 'Sprich flüssiger.',
  'Arrij B2.': 'Erreiche B2.',
  'Platforma jote për fjalor, gramatikë dhe praktikë reale në gjuhën gjermane.': 'Deine Plattform für Wortschatz, Grammatik und echte Praxis in deutscher Sprache.',
  'Niveli': 'Niveau',
  'Fjalori': 'Wortschatz',
  'Përditëso profilin': 'Profil aktualisieren',
  'Emri juaj': 'Dein Vorname',
  'Mbiemri juaj': 'Dein Nachname',
  'Fotografia nuk u ngarkua. Provo përsëri.': 'Das Profilbild konnte nicht hochgeladen werden. Bitte versuche es erneut.',
  'Fotografia duhet të jetë më e vogël se 5 MB.': 'Das Bild muss kleiner als 5 MB sein.',
  'Zgjidh një fotografi JPG, PNG ose WebP.': 'Wähle ein JPG-, PNG- oder WebP-Bild aus.',
  'Duhet të jesh i kyçur për të ndryshuar fotografinë.': 'Du musst angemeldet sein, um dein Profilbild zu ändern.',
  'Duke ngarkuar...': 'Wird hochgeladen ...',
  'Duke ruajtur...': 'Wird gespeichert ...',
  'Profili u ruajt! Kontrollo email-in e ri për konfirmim.': 'Profil gespeichert! Bitte bestätige deine neue E-Mail-Adresse.',
  'Profili u përditësua me sukses!': 'Profil erfolgreich aktualisiert!',
  'Dështoi përditësimi i profilit.': 'Das Profil konnte nicht aktualisiert werden.',
  'Ky shfletues nuk i mbështet njoftimet në desktop.': 'Dieser Browser unterstützt keine Desktop-Benachrichtigungen.',
  'Nuk u arrit të kërkohet leja për njoftimet.': 'Die Berechtigung für Benachrichtigungen konnte nicht angefordert werden.',
  'Lejo njoftimet në shfletues për t’i aktivizuar.': 'Erlaube Benachrichtigungen in deinem Browser, um sie zu aktivieren.',
  'Llogaria nuk ka adresë emaili për verifikim.': 'Für dieses Konto ist keine E-Mail-Adresse zur Verifizierung hinterlegt.',
  'Fjalëkalimi aktual nuk është i saktë.': 'Das aktuelle Passwort ist falsch.',
  'Fjalëkalimi u ndryshua me sukses.': 'Passwort erfolgreich geändert.',
  'Dështoi ndryshimi i fjalëkalimit.': 'Das Passwort konnte nicht geändert werden.',
  'Cilësimet u ruajtën me sukses!': 'Einstellungen erfolgreich gespeichert!',
  'Profili u përditësua.': 'Profil aktualisiert.',
  'Fotografia e profilit u përditësua.': 'Profilbild aktualisiert.',
  'Fotografia u hoq nga profili.': 'Profilbild aus dem Profil entfernt.',
  'Fotografia u hoq nga profili, por skedari nuk u fshi plotësisht.': 'Profilbild entfernt, die Datei konnte jedoch nicht vollständig gelöscht werden.',
  'Fotografia nuk u hoq. Provo përsëri.': 'Das Profilbild konnte nicht entfernt werden. Bitte versuche es erneut.',
  'Fjalëkalimet nuk përputhen.': 'Die Passwörter stimmen nicht überein.',
  'Përgjigje': 'Antwort',
  'Kliko butonin "Confirm your email"': 'Klicke auf die Schaltfläche „Confirm your email“',
  dhe: 'und',
  'Duke krijuar...': 'Konto wird erstellt ...',
  'Krijo llogari': 'Konto erstellen',
  'të palexuara': 'ungelesen',
  'Njoftimet dhe tingujt': 'Benachrichtigungen und Töne',
  'Filan': 'Max',
  'Fisteku': 'Mustermann',
  'Nuk u ngarkuan statistikat.': 'Statistiken konnten nicht geladen werden.',
  'Verifiko fjalëkalimin aktual dhe vendos një të ri të sigurt.': 'Bestätige dein aktuelles Passwort und wähle ein neues, sicheres Passwort.',
  'Ju lutem vendosni të paktën emrin ose emrin e përdoruesit.': 'Bitte gib mindestens deinen Namen oder Benutzernamen ein.',
};

const dynamicTranslations = [
  [/^Bisedë e re$/i, () => 'Neuer Chat'],
  [/^Krijo grup \((\d+)\)$/, (_, count) => `Gruppe erstellen (${count})`],
  [/^Aktiv para (\d+)m$/, (_, minutes) => `Vor ${minutes} Min.`],
  [/^Aktiv para (\d+)h$/, (_, hours) => `Vor ${hours} Std.`],
  [/^Parë Sot, (.+)$/, (_, time) => `Zuletzt gesehen: heute um ${time}`],
  [/^Aktiv para (\d+)d$/, (_, days) => `Vor ${days} Tagen`],
  [/^Përgjigjja (\d+)$/, (_, number) => `Antwort ${number}`],
  [/^Hiq përgjigjen (\d+)$/, (_, number) => `Antwort ${number} entfernen`],
  [/^(\d+)\s+fjalë$/, (_, count) => `${count} Wörter`],
  [/^(\d+)\s+shprehje$/, (_, count) => `${count} Redewendungen`],
  [/^(\d+)\s+të ruajtura$/, (_, count) => `${count} gespeichert`],
  [/^Niveli (.+)$/, (_, level) => `Niveau ${level}`],
  [/^Kalon me ≥ (.+)$/, (_, score) => `Bestanden ab ≥ ${score}`],
  [/^Pyetja (\d+) nga (\d+)$/, (_, question, total) => `Frage ${question} von ${total}`],
  [/^Shfaqen (.+) nga (.+) rezultate$/, (_, range, total) => `Angezeigt: ${range} von ${total} Ergebnissen`],
  [/^(\d+) nga (\d+)$/, (_, score, total) => `${score} von ${total}`],
  [/^(\d+) minuta lexim$/, (_, minutes) => `${minutes} Minuten Lesezeit`],
  [/^(\d+) fjalë janë shënuar si të njohura\.$/, (_, count) => `${count} Wörter sind als bekannt markiert.`],
  [/^Rezultati juaj: (.+)$/, (_, result) => `Dein Ergebnis: ${result}`],
];

function translateText(text, language) {
  if (language !== 'de') return text;
  if (translations[text]) return translations[text];
  for (const [pattern, translate] of dynamicTranslations) {
    const match = text.match(pattern);
    if (match) return translate(...match);
  }
  return text;
}

const LanguageContext = createContext(null);

function getInitialLanguage() {
  try {
    const storage = getStorage();
    const savedLanguage = storage ? storage.getItem(LANGUAGE_STORAGE_KEY) : null;
    return savedLanguage === 'de' ? 'de' : 'sq';
  } catch (error) {
    console.error('Unable to read the saved app language:', error);
    return 'sq';
  }
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = (nextLanguage) => {
    if (!['sq', 'de'].includes(nextLanguage)) {
      throw new Error(`Unsupported app language: ${nextLanguage}`);
    }
    try {
      const storage = getStorage();
      if (storage) {
        storage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
      }
    } catch (error) {
      console.error('Unable to save the app language:', error);
    }
    setLanguageState(nextLanguage);
  };

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    const translateTextNode = (node) => {
      const parent = node.parentElement;
      if (!parent || parent.closest(TRANSLATION_EXCLUSIONS)) return;

      const previous = TEXT_TRANSLATIONS.get(node);
      const original = previous && node.nodeValue === previous.translated
        ? previous.original
        : node.nodeValue;
      const match = original.match(/^(\s*)([\s\S]*?)(\s*)$/);
      if (!match || !match[2]) return;

      const translated = translateText(match[2], language);
      const nextValue = `${match[1]}${translated}${match[3]}`;
      TEXT_TRANSLATIONS.set(node, { original, translated: nextValue });
      if (node.nodeValue !== nextValue) node.nodeValue = nextValue;
    };

    const translateAttributes = (element, changedAttribute = null) => {
      if (element.closest(TRANSLATION_EXCLUSIONS)) return;
      const attributes = changedAttribute
        ? [changedAttribute]
        : LOCALIZABLE_ATTRIBUTES;
      attributes.forEach((attribute) => {
        if (!LOCALIZABLE_ATTRIBUTES.includes(attribute) || !element.hasAttribute(attribute)) return;
        const current = element.getAttribute(attribute);
        let stored = ATTRIBUTE_TRANSLATIONS.get(element);
        if (!stored) {
          stored = new Map();
          ATTRIBUTE_TRANSLATIONS.set(element, stored);
        }
        const previous = stored.get(attribute);
        const original = previous && current === previous.translated
          ? previous.original
          : current;
        const translated = translateText(original, language);
        stored.set(attribute, { original, translated });
        if (current !== translated) element.setAttribute(attribute, translated);
      });
    };

    const translateSubtree = (root) => {
      if (root.nodeType === Node.TEXT_NODE) {
        translateTextNode(root);
        return;
      }
      if (!(root instanceof Element) || root.closest(TRANSLATION_EXCLUSIONS)) return;

      translateAttributes(root);
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();
      while (node) {
        translateTextNode(node);
        node = walker.nextNode();
      }
    };

    translateSubtree(document.body);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          translateTextNode(mutation.target);
        } else if (mutation.type === 'attributes') {
          translateAttributes(mutation.target, mutation.attributeName);
        } else {
          mutation.addedNodes.forEach(translateSubtree);
        }
      });
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: LOCALIZABLE_ATTRIBUTES,
    });

    return () => observer.disconnect();
  }, [language]);

  const value = useMemo(() => ({
    language,
    setLanguage,
    t: (text) => translateText(text, language),
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
}
